import { AnyAction, Dispatch } from 'redux';
import { connect } from 'react-redux';

import { loadRelated } from 'modules/job-types/duck';
import { openNewRequestModal } from 'modules/requests/service';
import { proSelector, proJobTypesSelector } from 'modules/users/duck';

import ProProfileContent from './ProProfileContent';
import { Pro } from '../../types';

import { RootState } from 'store/types';

const mapStateToProps = (state: RootState) => ({
  pro: proSelector(state) as Pro,
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
  requestableJobTypes: proJobTypesSelector(state).filter(
    (jToken: { clientRequest: boolean }) => jToken.clientRequest
  ) as Array<{
    id: string;
    title: string;
  }>,
});

// TODO: add getJobTags for c2 translations

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
  loadRelated({
    jobTypeId,
    requestableOnly = true,
  }: {
    jobTypeId: string;
    requestableOnly: boolean;
  }) {
    dispatch(loadRelated({ jobTypeId, requestableOnly }));
  },
  openRequestModal(jobTypeId: string) {
    return openNewRequestModal({
      dispatch,
      properties: { jobTypeId },
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProProfileContent);
